import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Button, Card, CardContent, Container, Skeleton, Stack, Typography } from '@mui/material';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';

import ordersApi from '../../api/ordersApi';
import { getErrorMessage } from '../../utils/errorHandler';
import CustomerOrderCard from '../../sections/client/account/CustomerOrderCard';

// "Mis pedidos": historial de compras del cliente autenticado, con su seguimiento y la descarga
// de la boleta/factura cuando ya fue emitida.
export default function OrderHistoryPage() {
  const { enqueueSnackbar } = useSnackbar();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ordersApi
      .getMyOrders({ per_page: 50 })
      .then(({ data }) => setOrders(data.data))
      .catch((error) => enqueueSnackbar(getErrorMessage(error, 'No se pudieron cargar tus pedidos.'), { variant: 'error' }))
      .finally(() => setLoading(false));
  }, [enqueueSnackbar]);

  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Stack spacing={1} sx={{ mb: 4 }}>
        <Typography variant="h4">Mis pedidos</Typography>
        <Typography color="text.secondary">
          Seguimiento de tus compras: pedido recibido, pago confirmado y comprobante emitido.
        </Typography>
      </Stack>

      {loading && (
        <Stack spacing={2}>
          <Skeleton variant="rounded" height={200} />
          <Skeleton variant="rounded" height={200} />
        </Stack>
      )}

      {!loading && orders.length === 0 && (
        <Card>
          <CardContent>
            <Stack spacing={2} sx={{ alignItems: 'center', textAlign: 'center', py: 4 }}>
              <ShoppingBagOutlinedIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
              <Typography variant="h6">Aún no tienes pedidos</Typography>
              <Button variant="contained" component={RouterLink} to="/catalogo">
                Ir al catálogo
              </Button>
            </Stack>
          </CardContent>
        </Card>
      )}

      <Stack spacing={2}>
        {orders.map((order) => (
          <CustomerOrderCard key={order.id} order={order} />
        ))}
      </Stack>
    </Container>
  );
}
